import React from 'react';
import { useTranslation } from 'react-i18next';
import { LegalLayout, LegalSection } from '../../components/LegalLayout';

/**
 * PrivacyPage — Informativa privacy completa (House Cash Flows LTD).
 *
 * ★ 2026-08-27 (Phase 57.B) — GDPR-compliant privacy policy con contenuto
 * i18n (IT/EN/ES) e dati Titolare del trattamento (HCF LTD, Bulgaria).
 */
export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <LegalLayout
      docType="privacy"
      title={t('legal.privacy.pageTitle', 'Privacy Policy')}
      intro={t('legal.privacy.intro', '')}
    >
      <LegalSection id="s1" title={t('legal.privacy.s1Title', '1. Chi siamo')}>
        {t('legal.privacy.s1Body', '')}
      </LegalSection>
      <LegalSection id="s2" title={t('legal.privacy.s2Title', '2. Dati raccolti')}>
        {t('legal.privacy.s2Body', '')}
      </LegalSection>
      <LegalSection id="s3" title={t('legal.privacy.s3Title', '3. Finalità')}>
        {t('legal.privacy.s3Body', '')}
      </LegalSection>
      <LegalSection id="s4" title={t('legal.privacy.s4Title', '4. Condivisione')}>
        {t('legal.privacy.s4Body', '')}
      </LegalSection>
      <LegalSection id="s5" title={t('legal.privacy.s5Title', '5. Trasferimenti extra-UE')}>
        {t('legal.privacy.s5Body', '')}
      </LegalSection>
      <LegalSection id="s6" title={t('legal.privacy.s6Title', '6. Retention')}>
        {t('legal.privacy.s6Body', '')}
      </LegalSection>
      <LegalSection id="s7" title={t('legal.privacy.s7Title', '7. Diritti')}>
        {t('legal.privacy.s7Body', '')}
      </LegalSection>
      <LegalSection id="s8" title={t('legal.privacy.s8Title', '8. Sicurezza')}>
        {t('legal.privacy.s8Body', '')}
      </LegalSection>
      <LegalSection id="s9" title={t('legal.privacy.s9Title', '9. Minori')}>
        {t('legal.privacy.s9Body', '')}
      </LegalSection>
      <LegalSection id="s10" title={t('legal.privacy.s10Title', '10. Modifiche')}>
        {t('legal.privacy.s10Body', '')}
      </LegalSection>
    </LegalLayout>
  );
}
